'use strict';

var shippingAddressHelper = require('../checkout/shippingAddress');

module.exports = function () {
    $('.check-link').on('click', function () {
        var $pincodeField = $('input.pincode-input');
        var pincodeValue = $pincodeField.val().trim();

        var url = $(this).data('url');
        var $form = $(this).closest('.popup-body');
        var $errorFeedback = $form.find('.pincode-error');
        var $pincodeContainer = $(this).closest('.loginpopup-formdiv');

        var countryValue = $('.py-country-iso-code.selected').data('value');

        $pincodeField.removeClass('is-invalid');
        $errorFeedback.addClass('d-none');

        if (!pincodeValue || !/^\d{6}$/.test(pincodeValue)) {
            $pincodeField.addClass('is-invalid');
            $errorFeedback.removeClass('d-none').text('Please enter a valid Pincode');
            $pincodeContainer.addClass('invaild-pincode');
            return;
        }

        if (shippingAddressHelper.isInvalidPincode(pincodeValue)) {
            $pincodeField.addClass('is-invalid');
            $errorFeedback.removeClass('d-none').text('Please enter a valid Pincode');
            $pincodeContainer.addClass('invaild-pincode');
            return;
        }

        $.ajax({
            url: url,
            method: 'POST',
            dataType: 'json',
            data: {
                pincode: pincodeValue,
                countryCode: countryValue
            },
            success: function (response) {
                if (response.success === true) {
                    $('#deliveryCheckModal').modal('hide');
                    $('body').trigger('successToast', 'Location Captured successfully');
                } else {
                    $('.pincode-error').removeClass('d-none');
                }
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    // Trigger .check-link click on Enter key press
    $(document).on('keydown', 'input.pincode-input', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault(); // prevent form submit
            $(this).closest('.popup-body').find('.check-link').trigger('click');
        }
    });

    $('input.pincode-input').on('input', function () {
        if ($(this).hasClass('zip-field')) {
            $(this).val(
                $(this).val()
                    .trimStart()
                    .replace(/[^A-Z0-9]/g, '')
                    .replace(/^0+/, '')
            );
        } else {
            $(this).val($(this).val().trimStart().replace(/[^0-9]/g, '')
                .replace(/^0+/, ''));
        }
        $(this).removeClass('is-invalid');
        $(this).closest('.popup-body').find('.pincode-error').addClass('d-none');
        $(this).closest('.loginpopup-formdiv').removeClass('invaild-pincode');
    });

    if (!sessionStorage.getItem('modalShown')) {
        setTimeout(function () {
            /**
             * Shows the delivery modal after a delay.
             */
            function showDeliveryModalAfterDelay() {
                setTimeout(function () {
                    // final check - no modal is open
                    if (!$('.modal:visible').length) {
                        $('#deliveryCheckModal').modal('show');
                        sessionStorage.setItem('modalShown', 'true');
                    }
                }, 5000); // 5 seconds after last modal closed
            }

            // Check if login or remainder modal is open
            if ($('#loginPopupModal').is(':visible') || $('#downloadCatalog').is(':visible')) {
                $(document).one('hidden.bs.modal', function () {
                    // if still another modal open, wait again
                    if (!$('.modal:visible').length) {
                        showDeliveryModalAfterDelay();
                    } else {
                        // Reattach listener until all modals closed
                        $(document).one('hidden.bs.modal', function () {
                            if (!$('.modal:visible').length) {
                                showDeliveryModalAfterDelay();
                            }
                        });
                    }
                });
            } else {
                // No modal blocking → show delivery check immediately
                $('#deliveryCheckModal').modal('show');
                sessionStorage.setItem('modalShown', 'true');
            }
        }, 60000); // initial 1 min delay
    }

    $(document).on('change', '#countryFlagSelector', function () {
        var parent = $(this).closest('.loginpopup-formdiv');
        parent.removeClass('invaild-pincode');
        var selectedCode = $(this).val().trim();
        var countryJson = JSON.parse($('#countriesConfig').val());
        var labelText = $('.pincode-wrap .pincode-label');

        parent.find('.pincode-wrap .pincode-input').removeClass('is-invalid');
        parent.find('.pincode-wrap .errormsg').addClass('d-none');
        $('.delivery-availability-popup .pincode-error').addClass('d-none');
        parent.find('.pincode-wrap .pincode-input').val('');

        for (const item of countryJson) {  // eslint-disable-line
            var countryName = Object.keys(item)[0];
            var countryCodeselected = item[countryName].countryCode;
            if (countryCodeselected === selectedCode) {
                var minLen = item[countryName].dynamicForms.addressDetails.pincode['min-length'];
                var maxLen = item[countryName].dynamicForms.addressDetails.pincode['max-length'];
                var regex = item[countryName].dynamicForms.addressDetails.pincode['.regex'];
                parent.find('.pincode-wrap .pincode-input')
                    .attr('maxlength', maxLen)
                    .attr('minlength', minLen)
                    .attr('regex', regex);
                var serviceabilityCheckFieldName = item[countryName].serviceabilityCheckFieldName;
                var countryIsoCode = $('.py-country-iso-code.selected').attr('value');
                if (serviceabilityCheckFieldName === 'pincode') {
                    if (countryIsoCode === 'IN') {
                        labelText.text('Enter Pincode');
                        parent.find('.pincode-wrap .pincode-input').removeClass('zip-field');
                    } else {
                        labelText.text('Enter Zipcode');
                        parent.find('.pincode-wrap .pincode-input').addClass('zip-field');
                    }
                } else {
                    labelText.text('Enter a City');
                }
                break;
            }
        }
    });
};
